<template>
  <label
    :class="textAreaStyleClass"
    @mousedown="isMouseButtonDown = true"
    @mouseup="isMouseButtonDown = false"
  >
    <textarea
      :class="$style.textarea__native"
      :rows="rows"
      :id="id"
      v-model="value"
      @focus="hasFocus = true"
      @blur="hasFocus = false"
    />
    <div
      :class="$style.attachments"
      @mousedown.stop=""
      @click.stop=""
      v-if="$slots.attachments"
    >
      <slot name="attachments" />
    </div>
  </label>
</template>

<script setup lang="ts">
import { computed, ref, useCssModule } from 'vue'
const props = withDefaults(
  defineProps<{ modelValue: string; rows: number; id?: string }>(),
  {
    id: Math.random().toString(32),
  }
)
const emits = defineEmits<{ 'update:modelValue': [text: string] }>()
const isMouseButtonDown = ref(false)
const hasFocus = ref(false)
const style = useCssModule()
const textAreaStyleClass = computed(() => [
  style.textarea,
  { [style['textarea--focus']]: hasFocus.value || isMouseButtonDown.value },
])

const value = computed({
  get: () => props.modelValue,
  set: (value: string) => {
    emits('update:modelValue', value)
  },
})
</script>

<style module lang="scss">
.attachments {
  width: fit-content;
}

.textarea {
  display: block;

  &__native {
    resize: inherit;
    width: 100%;

    &:focus-visible {
      outline: none;
    }
  }

  &--focus {
    outline: $color-border-accent-primary auto 1px;
  }
}
</style>
